"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformLocalDateToString = transformLocalDateToString;
const DayOfWeek_1 = require("../utils/DayOfWeek");
const monthNames_1 = require("../utils/monthNames");
function transformLocalDateToString(date, showDayOfWeek = false) {
    const dateToString = new Date(date);
    const year = dateToString.getFullYear().toString();
    const month = monthNames_1.monthNames[dateToString.getMonth()];
    const day = dateToString.getDate().toString();
    let dayOfWeek = "";
    if (showDayOfWeek) {
        dayOfWeek = `${DayOfWeek_1.DaysOfWeek[dateToString.getDay()]}, `;
    }
    return `${dayOfWeek}${month} ${day}, ${year}`;
}
//# sourceMappingURL=transformLocalDateToString.js.map